import ApiService from '@/api/http/ApiService';
import { Release } from '@/interfaces/models/Release';
import { Page } from '@/interfaces/api/Page';
import Filter from '@/interfaces/api/Filter';
import { Pagination } from '@/interfaces/api/Pagination';
import axios, { AxiosPromise } from 'axios';

export default class ReleasesApiService extends ApiService<Release> {
  constructor() {
    super('app/releases', 'v1');
  }

  public getReleases(page: Page, filter: Filter): AxiosPromise<Release[] | Pagination<Release>> {
    if (page) {
      return axios.get(`${this.getBaseUrl()}`, {
        params: { page, limit: 10, customerGroup: filter.customerGroup || false },
      });
    }

    return axios.get(`${this.getBaseUrl()}`);
  }
}
